export default __webpack_public_path__ + "static/banner-managing-your-bridal-party-f69274e895fe405cee4ecef216ef91be.jpg";